import React from "react";
import { useSelector } from "react-redux";

export default function OrderPrice() {
  const order = useSelector((state) => state.cart.cart);
  const { profile } = useSelector((state) => state.profile);
  let allPrice = 0;
  let currency = profile?.currency || "AED";
  
  for (var i = 0; i < order.length; i++) {
    allPrice += order[i].price * order[i].quantity;
  }

  const total = parseFloat(allPrice.toFixed(2));
  
  return (
    <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg md:rounded-xl p-3 md:p-4 lg:p-6 border border-gray-200">
      <h3 className="text-sm md:text-base lg:text-lg font-semibold text-gray-800 mb-2 md:mb-3 lg:mb-4 poppins">Order Summary</h3>
      
      <div className="space-y-1.5 md:space-y-2 lg:space-y-3">
        <div className="border-t border-gray-300 pt-1.5 md:pt-2 lg:pt-3 mt-1.5 md:mt-2 lg:mt-3">
          <div className="flex items-center justify-between">
            <span className="text-base md:text-lg lg:text-xl font-bold text-gray-800 poppins">Total</span>
            <span className={`text-base md:text-lg lg:text-xl font-bold text-primary poppins ${currency === 'AED' ? 'currency-aed' : ''}`}>
              {currency} {total.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
